class Location {
    constructor(locationId) {
        this.locationId = locationId;
    }

    getServicesAsHtml(services) {
        let html = '';

        if (services.length > 0) {
            services.forEach(service => {
                html +=`
                <a class="service" href="${service.url}">
                    <div class="service-title">${service.title}</div>
                    <div class="service-excerpt">${service.excerpt}</div>
                </a>
                `;
            });
        }

        return html;
    }
}

export default Location;
